import i18n from './translate';
i18n.loadTranslations();
export default i18n;
